// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Render Success Modal Styles */

.bulk-success-modal {
  max-width: 650px;
  width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
}

.bulk-success-modal .modal-body {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.bulk-success-modal h2 {
  color: #28a745;
  font-size: 24px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.success-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Render Summary */
.render-summary h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.summary-stats {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 16px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  border-radius: 12px;
  min-width: 120px;
}

.stat-item.success {
  background: linear-gradient(135deg, #d4edda, #c3e6cb);
  border: 2px solid #28a745;
}

.stat-item.failure {
  background: linear-gradient(135deg, #f8d7da, #f5c6cb);
  border: 2px solid #dc3545;
}

.stat-number {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Language Results */
.language-results h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.result-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  border-radius: 6px;
  border-left: 4px solid #28a745;
}

.result-item.failed {
  border-left-color: #dc3545;
}

.result-status {
  font-size: 18px;
  flex-shrink: 0;
}

.result-info {
  flex-grow: 1;
}

.language-name {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.result-details {
  font-size: 14px;
  color: #6c757d;
  margin-top: 4px;
}

.error-details {
  font-size: 14px;
  color: #dc3545;
  margin-top: 4px;
}

/* Upload Results */
.upload-results h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.upload-status {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  background: #f8f9fa;
}

.upload-status.success {
  background: linear-gradient(135deg, #d4edda, #c3e6cb);
  border-color: #28a745;
}

.upload-status.error {
  background: linear-gradient(135deg, #f8d7da, #f5c6cb);
  border-color: #dc3545;
}

.upload-status.processing {
  background: linear-gradient(135deg, #d1ecf1, #bee5eb);
  border-color: #17a2b8;
  animation: pulse-sync 2s infinite;
}

@keyframes pulse-sync {
  0% { transform: scale(1); border-color: #17a2b8; }
  50% { transform: scale(1.02); border-color: #007bff; }
  100% { transform: scale(1); border-color: #17a2b8; }
}

.upload-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.upload-details {
  flex-grow: 1;
}

.upload-title {
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
}

.upload-message {
  font-size: 14px;
  color: #666;
  white-space: pre-line;
  line-height: 1.4;
}

/* Sound Notification */
.sound-notification {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border: 2px solid #ffc107;
  border-radius: 8px;
  align-items: center;
}

.notification-icon {
  font-size: 24px;
  flex-shrink: 0;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.notification-text {
  font-size: 14px;
  color: #856404;
  line-height: 1.4;
}

.notification-text strong {
  color: #533301;
}

/* Modal Footer */
.bulk-success-modal .modal-footer {
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid #eee;
}

.modal-acknowledge-button {
  padding: 12px 24px;
  border: none;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-acknowledge-button:hover {
  background: linear-gradient(135deg, #20c997, #17a2b8);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .bulk-success-modal {
    width: 98vw;
    max-width: none;
    max-height: 90vh;
  }

  .bulk-success-modal .modal-body {
    padding: 16px;
    max-height: 75vh;
  }

  .success-content {
    gap: 20px;
  }

  .summary-stats {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .stat-item {
    width: 100%;
    max-width: 200px;
  }

  .sound-notification {
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }

  .modal-acknowledge-button {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BulkRenderSuccessModal.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,KAAK,mBAAmB,EAAE,qBAAqB,EAAE;EACjD,MAAM,sBAAsB,EAAE,qBAAqB,EAAE;EACrD,OAAO,mBAAmB,EAAE,qBAAqB,EAAE;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Bulk Render Success Modal Styles */\n\n.bulk-success-modal {\n  max-width: 650px;\n  width: 95vw;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.bulk-success-modal .modal-body {\n  padding: 20px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.bulk-success-modal h2 {\n  color: #28a745;\n  font-size: 24px;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.success-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Render Summary */\n.render-summary h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.summary-stats {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 24px;\n  border-radius: 12px;\n  min-width: 120px;\n}\n\n.stat-item.success {\n  background: linear-gradient(135deg, #d4edda, #c3e6cb);\n  border: 2px solid #28a745;\n}\n\n.stat-item.failure {\n  background: linear-gradient(135deg, #f8d7da, #f5c6cb);\n  border: 2px solid #dc3545;\n}\n\n.stat-number {\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Language Results */\n.language-results h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 8px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.result-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: white;\n  border-radius: 6px;\n  border-left: 4px solid #28a745;\n}\n\n.result-item.failed {\n  border-left-color: #dc3545;\n}\n\n.result-status {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.result-info {\n  flex-grow: 1;\n}\n\n.language-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 16px;\n}\n\n.result-details {\n  font-size: 14px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n.error-details {\n  font-size: 14px;\n  color: #dc3545;\n  margin-top: 4px;\n}\n\n/* Upload Results */\n.upload-results h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.upload-status {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n  border: 2px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.upload-status.success {\n  background: linear-gradient(135deg, #d4edda, #c3e6cb);\n  border-color: #28a745;\n}\n\n.upload-status.error {\n  background: linear-gradient(135deg, #f8d7da, #f5c6cb);\n  border-color: #dc3545;\n}\n\n.upload-status.processing {\n  background: linear-gradient(135deg, #d1ecf1, #bee5eb);\n  border-color: #17a2b8;\n  animation: pulse-sync 2s infinite;\n}\n\n@keyframes pulse-sync {\n  0% { transform: scale(1); border-color: #17a2b8; }\n  50% { transform: scale(1.02); border-color: #007bff; }\n  100% { transform: scale(1); border-color: #17a2b8; }\n}\n\n.upload-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.upload-details {\n  flex-grow: 1;\n}\n\n.upload-title {\n  font-weight: 600;\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.upload-message {\n  font-size: 14px;\n  color: #666;\n  white-space: pre-line;\n  line-height: 1.4;\n}\n\n/* Sound Notification */\n.sound-notification {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: linear-gradient(135deg, #fff3cd, #ffeaa7);\n  border: 2px solid #ffc107;\n  border-radius: 8px;\n  align-items: center;\n}\n\n.notification-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n  100% { transform: scale(1); }\n}\n\n.notification-text {\n  font-size: 14px;\n  color: #856404;\n  line-height: 1.4;\n}\n\n.notification-text strong {\n  color: #533301;\n}\n\n/* Modal Footer */\n.bulk-success-modal .modal-footer {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  border-top: 1px solid #eee;\n}\n\n.modal-acknowledge-button {\n  padding: 12px 24px;\n  border: none;\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.modal-acknowledge-button:hover {\n  background: linear-gradient(135deg, #20c997, #17a2b8);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .bulk-success-modal {\n    width: 98vw;\n    max-width: none;\n    max-height: 90vh;\n  }\n\n  .bulk-success-modal .modal-body {\n    padding: 16px;\n    max-height: 75vh;\n  }\n\n  .success-content {\n    gap: 20px;\n  }\n\n  .summary-stats {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .stat-item {\n    width: 100%;\n    max-width: 200px;\n  }\n\n  .sound-notification {\n    flex-direction: column;\n    text-align: center;\n    gap: 8px;\n  }\n\n  .modal-acknowledge-button {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
